import type { ReactNode } from 'react'

interface SectionProps {
  id: string
  eyebrow?: string
  title: ReactNode
  description?: ReactNode
  children: ReactNode
}

function Section({ id, eyebrow, title, description, children }: SectionProps) {
  return (
    <section id={id} className="mx-auto max-w-7xl scroll-mt-20 px-5 py-16 md:py-20">
      <div className="animate-fade-up">
        {eyebrow ? (
          <span className="mb-3 inline-block rounded-full border border-indigo-400/30 bg-indigo-500/10 px-3 py-1 font-mono text-xs font-medium uppercase tracking-wider text-indigo-300">
            {eyebrow}
          </span>
        ) : null}
        <h2 className="font-display text-3xl font-bold tracking-tight text-white md:text-4xl">
          {title}
        </h2>
        {description ? (
          <p className="mt-3 max-w-2xl text-base leading-relaxed text-slate-400">
            {description}
          </p>
        ) : null}
      </div>
      <div className="mt-8">{children}</div>
    </section>
  )
}

export default Section
